import React from 'react';
import classNames from 'classnames';

import { useQueryParams } from 'hooks/useQueryParams';

import { ErrorBoundary } from 'components';
import { SettingsTabsType } from 'helpers/constants';

import { Header, OrganizationApps, Members } from './components';

import styles from './SettingsScreen.module.scss';

export const SettingsScreen = () => {
  return (
    <ErrorBoundary>
      <div className={styles.content}>
        <div className={classNames(styles.contentBin, styles.layoutMain)}>
          <div className={styles.MainColumn}>
            <Header />
            <ErrorBoundary>
              <SettingsContent />
            </ErrorBoundary>
          </div>
        </div>
      </div>
    </ErrorBoundary>
  );
};

const SettingsContent: React.FC = () => {
  const query = useQueryParams();
  const currentTab = query.get('tab');

  if (currentTab === SettingsTabsType.MEMBERS) {
    /* TODO - #32 Analytics
      tracking.trackEvent({
        event: eventTrackingNames.settings.viewMembers
      });
    */
    return <Members />;
  }

  /* TODO - #32 Analytics
    tracking.trackEvent({
      event: eventTrackingNames.settings.viewApps
    });
  */
  return <OrganizationApps />;
};
